// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wmde-markdown-color .token.tag .attr-value {
  color: #032f62;
}
.wmde-markdown-color .token.property,
.wmde-markdown-color .token.tag,
.wmde-markdown-color .token.boolean,
.wmde-markdown-color .token.number,
.wmde-markdown-color .token.function-name,
.wmde-markdown-color .token.constant,
.wmde-markdown-color .token.symbol,
.wmde-markdown-color .token.deleted {
  color: #0060c9;
}
.wmde-markdown-color .token.punctuation {
  color: #a0a0a0;
}
.wmde-markdown-color code[class*="language-"] {
  color: black;
}
.wmde-markdown-color code[class*="language-"] .token.selector,
.wmde-markdown-color code[class*="language-"] .token.attr-name,
.wmde-markdown-color code[class*="language-"] .token.string,
.wmde-markdown-color code[class*="language-"] .token.char,
.wmde-markdown-color code[class*="language-"] .token.function,
.wmde-markdown-color code[class*="language-"] .token.builtin {
  color: #6f42c1;
}
.wmde-markdown-color code[class*="language-"] .token.inserted {
  color: #22863a;
  background-color: #f0fff4;
}
.wmde-markdown-color code[class*="language-"] .token.deleted {
  color: #b31d28;
  background-color: #ffeef0;
}
.wmde-markdown-color code[class*="language-"] .token.class-name {
  color: #6f42c1;
}
.wmde-markdown-color code[class*="language-"] .code-block {
  color: #032f62;
}
.wmde-markdown-color code[class*="language-"] .token.comment,
.wmde-markdown-color code[class*="language-"] .token.block-comment,
.wmde-markdown-color code[class*="language-"] .token.prolog,
.wmde-markdown-color code[class*="language-"] .token.doctype,
.wmde-markdown-color code[class*="language-"] .token.cdata {
  color: #7D8B99;
}
.wmde-markdown-color code[class*="language-"] .token.punctuation {
  color: #a0a0a0;
}
.wmde-markdown-color code[class*="language-"] .token.operator,
.wmde-markdown-color code[class*="language-"] .token.entity,
.wmde-markdown-color code[class*="language-"] .token.url,
.wmde-markdown-color code[class*="language-"] .token.variable {
  color: #d73a49;
  background: rgba(255, 255, 255, 0.5);
}
.wmde-markdown-color code[class*="language-"] .token.atrule,
.wmde-markdown-color code[class*="language-"] .token.attr-value {
  color: #004698;
}
.wmde-markdown-color code[class*="language-"] .token.keyword {
  color: #d63200;
}
.wmde-markdown-color code[class*="language-"] .token.regex,
.wmde-markdown-color code[class*="language-"] .token.important {
  color: #e90;
}
.wmde-markdown-color code[class*="language-"] .token.string {
  color: #0a53c1;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@uiw/react-markdown-preview/lib/esm/styles/markdowncolor.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,cAAc;EACd,oCAAoC;AACtC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;AAChB","sourcesContent":[".wmde-markdown-color .token.tag .attr-value {\n  color: #032f62;\n}\n.wmde-markdown-color .token.property,\n.wmde-markdown-color .token.tag,\n.wmde-markdown-color .token.boolean,\n.wmde-markdown-color .token.number,\n.wmde-markdown-color .token.function-name,\n.wmde-markdown-color .token.constant,\n.wmde-markdown-color .token.symbol,\n.wmde-markdown-color .token.deleted {\n  color: #0060c9;\n}\n.wmde-markdown-color .token.punctuation {\n  color: #a0a0a0;\n}\n.wmde-markdown-color code[class*=\"language-\"] {\n  color: black;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.selector,\n.wmde-markdown-color code[class*=\"language-\"] .token.attr-name,\n.wmde-markdown-color code[class*=\"language-\"] .token.string,\n.wmde-markdown-color code[class*=\"language-\"] .token.char,\n.wmde-markdown-color code[class*=\"language-\"] .token.function,\n.wmde-markdown-color code[class*=\"language-\"] .token.builtin {\n  color: #6f42c1;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.inserted {\n  color: #22863a;\n  background-color: #f0fff4;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.deleted {\n  color: #b31d28;\n  background-color: #ffeef0;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.class-name {\n  color: #6f42c1;\n}\n.wmde-markdown-color code[class*=\"language-\"] .code-block {\n  color: #032f62;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.comment,\n.wmde-markdown-color code[class*=\"language-\"] .token.block-comment,\n.wmde-markdown-color code[class*=\"language-\"] .token.prolog,\n.wmde-markdown-color code[class*=\"language-\"] .token.doctype,\n.wmde-markdown-color code[class*=\"language-\"] .token.cdata {\n  color: #7D8B99;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.punctuation {\n  color: #a0a0a0;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.operator,\n.wmde-markdown-color code[class*=\"language-\"] .token.entity,\n.wmde-markdown-color code[class*=\"language-\"] .token.url,\n.wmde-markdown-color code[class*=\"language-\"] .token.variable {\n  color: #d73a49;\n  background: rgba(255, 255, 255, 0.5);\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.atrule,\n.wmde-markdown-color code[class*=\"language-\"] .token.attr-value {\n  color: #004698;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.keyword {\n  color: #d63200;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.regex,\n.wmde-markdown-color code[class*=\"language-\"] .token.important {\n  color: #e90;\n}\n.wmde-markdown-color code[class*=\"language-\"] .token.string {\n  color: #0a53c1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
